(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const logoCycleWords = [
    { text: 'Editions', color: '#6b7985' },
    { text: 'Photography', color: '#586768' },
    { text: 'Multiples', color: '#676f3c' },
    { text: 'Collage', color: '#244960' },
  ];

  function measureLogoDynamicWidth(container) {
    const currentWord = container.querySelector('.logo-dynamic');
    if (!currentWord) return;

    const computedStyle = window.getComputedStyle(currentWord);
    const measurer = document.createElement('span');

    measurer.className = 'logo-dynamic';
    measurer.style.font = computedStyle.font;
    measurer.style.letterSpacing = computedStyle.letterSpacing;
    measurer.style.left = '-9999px';
    measurer.style.position = 'absolute';
    measurer.style.top = '-9999px';
    measurer.style.visibility = 'hidden';
    measurer.style.whiteSpace = 'nowrap';

    document.body.appendChild(measurer);

    const maxWidth = logoCycleWords.reduce((width, word) => {
      measurer.textContent = word.text;
      return Math.max(width, measurer.getBoundingClientRect().width);
    }, 0);

    measurer.remove();
    container.style.setProperty('--logo-dynamic-width', `${Math.ceil(maxWidth)}px`);
  }

  function buildLogoWord(word, incoming = false) {
    const wordElement = document.createElement('span');
    wordElement.className = `logo-dynamic logo-dynamic-word${incoming ? ' word-in' : ''}`;
    wordElement.style.color = word.color;
    wordElement.textContent = word.text;

    return wordElement;
  }

  function initLogoWordCycle(root = document) {
    const logoInstances = [];

    if (root instanceof Element && root.matches('.header__heading-logo-text')) {
      logoInstances.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('.header__heading-logo-text').forEach((logo) => {
        logoInstances.push(logo);
      });
    }

    logoInstances.forEach((logo) => {
      const container = logo.querySelector('.logo-dynamic-container');
      if (!container) return;
      if (container.dataset.logoCycleInitialized === 'true') return;
      container.dataset.logoCycleInitialized = 'true';

      let wordIndex = 0;
      const currentWord = container.querySelector('.current-word');
      if (currentWord) currentWord.style.color = logoCycleWords[0].color;

      measureLogoDynamicWidth(container);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => measureLogoDynamicWidth(container));
      }

      window.addEventListener('resize', () => measureLogoDynamicWidth(container));

      window.setInterval(() => {
        if (!document.body.contains(container)) return;

        const outgoingWord = logoCycleWords[wordIndex];
        const nextIndex = (wordIndex + 1) % logoCycleWords.length;
        const incomingWord = logoCycleWords[nextIndex];
        const outgoingElement = buildLogoWord(outgoingWord);
        const incomingElement = buildLogoWord(incomingWord, true);

        container.replaceChildren(outgoingElement, incomingElement);

        window.requestAnimationFrame(() => {
          outgoingElement.classList.add('word-out');
          incomingElement.classList.add('is-visible');
        });

        window.setTimeout(() => {
          if (!document.body.contains(container)) return;

          const settledWord = document.createElement('span');
          settledWord.className = 'logo-dynamic current-word';
          settledWord.style.color = incomingWord.color;
          settledWord.textContent = incomingWord.text;
          container.replaceChildren(settledWord);
          wordIndex = nextIndex;
        }, 950);
      }, 4000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initLogoWordCycle());
  } else {
    initLogoWordCycle();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initLogoWordCycle(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
